import React, { Fragment } from 'react';
import { node, array, object, number, oneOfType, bool, string } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';
import styles from './Layout.css';

export const Layout = ({ children }) => (
  <div className={styles.tooltipLayout}>
    {children}
  </div>
);

Layout.propTypes = {
  children: node.isRequired
};

Layout.displayName = 'Layout';

export const Row = ({ children, spaceBetween }) => {
  if (children.length > 3) {
    throw Error(`Each row have a maximum of 3 childrens. You have ${children.length}.`);
  }
  return (
    <div className={classnames(styles.tooltipRow, 'flex-align-center', {'flex-justify-between': spaceBetween})}>
      {children}
    </div>
  );
};

Row.propTypes = {
  children: node.isRequired,
  spaceBetween: bool
};

Row.displayName = 'Row';

export const Title = ({ children }) => (
  <p className={styles.tooltipTitle}>{children}</p>
);

Title.propTypes = {
  children: node.isRequired
};

Title.displayName = 'Title';

export const Item = ({ children }) => (
  <p className="large">{children}</p>
);

Item.propTypes = {
  children: node.isRequired
};

Item.displayName = 'Item';

export const Label = ({ children }) => (
  <label className={styles.tooltipLabel}>
    {children}
  </label>
);

Label.propTypes = {
  children: node.isRequired
};

Label.displayName = 'Label';

export const Description = ({ children, maxWidth }) => (
  <p
    className={`small ${styles.tooltipDescription}`}
    style={maxWidth && {
      maxWidth: `${maxWidth}px`
    }}
  >
    {children}
  </p>
);

Description.propTypes = {
  children: node.isRequired,
  maxWidth: number
};

Description.displayName = 'Description';

export const List = ({ items }) => (
  <ul className={styles.tooltipList}>
    {items.map((item, i) => <li className={'list'} key={i}>{item.name || item}</li>)}
  </ul>
);

List.propTypes = {
  items: oneOfType([object, array]).isRequired
};

List.displayName = 'List';

export const ListElement = ({ children }) => (
  <p className={`list ${styles.tooltipListElement}`}>{children}</p>
);

ListElement.propTypes = {
  children: node.isRequired,
};

ListElement.displayName = 'ListElement';

export const MapTooltipIcons = ({icons}) => (
  <div className={styles.tooltipIcons}>
    {icons.map((icon, i) => (
      <Icon
        icon={icon.name || icon}
        type={'20'}
        key={`tooltip-icon-${i}`} />
    ))}
  </div>
);

MapTooltipIcons.propTypes = {
  icons: array,
};

MapTooltipIcons.displayName = 'MapTooltipIcons';

export const MapTooltipPoints = ({from, to}) => (
  <Fragment>
    <Description>{from}</Description>
    <Icon icon={'line'} type={'30'} customClasses={styles.tooltipPoints} />
    <Description>{to}</Description>
  </Fragment>
);

MapTooltipPoints.propTypes = {
  from: string,
  to: string
};

MapTooltipPoints.displayName = 'MapTooltipPoints';

export const Flag = ({ name }) => {
  const imagePath = require(`assets/images/flags/${name}.png`);

  return (
    <div className={styles.flag} style={{backgroundImage: `url(${imagePath})`}}>
    </div>
  );
};

Flag.propTypes = {
  name: string
};

Flag.displayName = 'Flag';

export const MapFlag = ({ title, flag, flagRight }) => (
  <div className={classnames('flex', flagRight && 'flex-justify-between flex-grow-1')}>
    {!flagRight && <Flag name={flag} />}
    <Title>{title}</Title>
    {flagRight && <Flag name={flag} />}
  </div>
);

MapFlag.propTypes = {
  title: string,
  flag: string,
  flagRight: bool
};

MapFlag.displayName = 'MapFlag';



// WEBPACK FOOTER //
// ./src/uis/elements/Tooltip/Layout/index.js